import styled from 'styled-components'

export const Container = styled.div`
display: flex;
cursor: pointer;
background: var(--terc6);
width: fit-content;
padding: .3rem 1rem .3rem .2rem;
border-radius: 2.5rem;

border: .25rem solid var(--terc6);

div:nth-child(1){
    background: white;
    color: var(--terc6);
    width: 4.5rem;
    height: 4.5rem;
    border-radius: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

div:nth-child(2){
    display: flex;
    align-items: center;
    color: white;
    padding-left: 1rem;
    padding-right: 1rem;
    span{
        font-weight: 700;
        font-size: 24px;
        font-family: 'Poppins';
    }
}

&:hover{
    transition: .3s;
    border: .25rem solid var(--terc4);
    box-shadow: var(--SombraBtns);
}
`

// height: 80px;
//
